__turbopack_context__.v({
  "cont": "footer-module-scss-module__opvy9W__cont",
  "links": "footer-module-scss-module__opvy9W__links",
  "powered-by": "footer-module-scss-module__opvy9W__powered-by",
  "powered-by-gender": "footer-module-scss-module__opvy9W__powered-by-gender",
  "powered-by-title": "footer-module-scss-module__opvy9W__powered-by-title",
  "subscribe-input-cont": "footer-module-scss-module__opvy9W__subscribe-input-cont",
  "subscribe-input-cont-error": "footer-module-scss-module__opvy9W__subscribe-input-cont-error",
  "subscribe-input-cont-toast-success": "footer-module-scss-module__opvy9W__subscribe-input-cont-toast-success",
  "subscribe-summary": "footer-module-scss-module__opvy9W__subscribe-summary",
  "subscribe-title": "footer-module-scss-module__opvy9W__subscribe-title",
});
